export function isValidInputType(cardNumber) {
    return typeof cardNumber === 'string' || cardNumber instanceof String;
}
//# sourceMappingURL=is-valid-input-type.js.map